import { all, call, put, select, takeLatest } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert } from "../Alerts/actions";
import { fetchChartBoardSuccess, fetchChartBoardFailure } from "./actions";
import { FETCH_CHART_BOARD } from "./constants";

export function* fetchChartBoardSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { id, from, to, residentId } = payload || {};
  const params = [];
  if (from) params.push(`from=${from}`);
  if (to) params.push(`to=${to}`);
  if (residentId) params.push(`resident_id=${residentId}`);
  const query = params.length ? `?${params.join("&")}` : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/location/${id}/chart-board${query}`,
    );
    // apiResponse wraps the body as { status, data: {...}, message }.
    const body = data?.data ?? data ?? {};
    yield put(
      fetchChartBoardSuccess({
        tiles: body.tiles ?? [],
        residents: body.residents ?? [],
        residentsTotal: body.residents_total ?? 0,
        range: body.range ?? null,
        locationId: body.location_id ?? null,
      }),
    );
  } catch (e) {
    yield put(fetchChartBoardFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Error while loading the chart board."));
  }
}

export function* fetchChartBoardFlow() {
  yield takeLatest(FETCH_CHART_BOARD, fetchChartBoardSaga);
}

export default function* ChartBoardSaga() {
  yield all([fetchChartBoardFlow()]);
}
